<template>
  <footer class="footer main-background secondary-text" aria-label="Footer">
    <div
      v-if="unfinishedTour.lastVisitedPoi && !currentTour.type"
      class="continue-tour"
      role="dialog"
      aria-label="Continue abounded tour"
    >
      <h3>{{ $t("message.continueAbandonedTour") }}</h3>
      <div class="buttons" role="presentation">
        <button
          class="btn btn-primary main-background secondary-text"
          @click="continueTour"
          @keypress="continueTour"
        >{{ $t("button.resume") }}</button>
        <button
          class="btn btn-primary main-background secondary-text"
          @click="cancelTour"
          @keypress="cancelTour"
        >{{ $t("button.home") }}</button>
      </div>
    </div>
    <div class="mobile-visible" role="presentation">
      <ctas></ctas>
    </div>
    <div class="desktop-visible">
      <span class="copyrights">© {{ currentYear() }} {{ collegeName }}</span>
      <div class="share" role="presentation" v-click-outside="hideShare">
        <button aria-controls="footer-social-share-menu" @click="shareOpen = !shareOpen">
          <span>Share</span>
          <img class="share-icon" src="../assets/share-icon.svg" alt="Share Icon">
        </button>
        <ul
          class="share-content"
          :class="{ active: shareOpen }"
          id="footer-social-share-menu"
          role="menu"
        >
          <li role="menuitem">
            <ShareNetwork
              network="facebook"
              :url="getUrl()"
              :title="collegeName"
              :description="truncate(`Exploring ${collegeName} through VisiTOUR`)"
            >
              <img height="16" src="../assets/facebook.svg" alt="Facebook Share">
              <span class="sr-only">Share on Facebook</span>
            </ShareNetwork>
          </li>
          <li role="menuitem">
            <ShareNetwork
              network="twitter"
              :url="getUrl()"
              :title="truncate(`Exploring ${collegeName} through VisiTOUR`)"
            >
              <img height="14" src="../assets/twitter.svg" alt="Twitter Share">
              <span class="sr-only">Share on Twitter</span>
            </ShareNetwork>
          </li>
        </ul>
      </div>
      <a href="http://studentbridge.com" target="_blank" title="StudentBridge">
        <img src="../assets/white-logo.png" alt="StudentBridge">
      </a>
    </div>
  </footer>
</template>

<script>
import CTAs from '@/components/CTAs'
import { mapState, mapMutations } from 'vuex'
import { settings } from '@/main'

var onceForm

export default {
  name: 'AppFooter',
  components: {
    'ctas': CTAs
  },
  data: function () {
    return {
      collegeName: this.$store.state.college.name,
      mainLogo: this.$store.state.college.settings.main_logo,
      studentTypes: this.$store.state.college.studentTypes,
      namecaptureSettings: this.$store.state.college.namecaptureSettings,
      shareOpen: false
    }
  },
  created () {
    var showDefaultNamecaptureForm = this.$store.state.college.showDefaultNamecaptureForm
    var ncToken = this.$store.state.college.namecaptureToken
    var ncSettings = this.$store.state.college.namecaptureSettings

    if (ncToken && settings.nameCaptureBaseUrl) {
      let promoScript = document.createElement('script')
      promoScript.setAttribute('src', settings.nameCaptureBaseUrl + '/static/lib/promotion2.js?v=1')

      let extraFields = [
        { name: 'lastname',
          label: (ncSettings &&
                  ncSettings.formLabels &&
                  ncSettings.formLabels.lastname ? ncSettings.formLabels.lastname : 'Last Name'),
          isRequired: true
        }
      ]

      if (this.studentTypes.length > 0) {
        extraFields.push({ name: 'role', label: 'I am a...', 'isRequired': true, 'type': 'dropdown', 'options': this.studentTypes })
      }

      let hidePhoneField = true
      let extraLink = null
      let rules = []

      if (ncSettings) {
        if (ncSettings.extraFields != null) {
          ncSettings.extraFields.forEach(function (extraField) {
            extraFields.push(extraField)
          })
        }
        if (ncSettings.hidePhoneField != null) {
          hidePhoneField = ncSettings.hidePhoneField
        }
        if (ncSettings.extraLink != null) {
          extraLink = ncSettings.extraLink
        }
        if (ncSettings.rules != null) {
          rules = ncSettings.rules
        }
      }

      promoScript.onload = () => {
        // eslint-disable-next-line
        onceForm = sbPromotion({
          url: settings.nameCaptureBaseUrl + '/v2/process-log/' + ncToken + '/',
          sourceApp: 'Visitour',
          hidePhoneField: hidePhoneField,
          rules: [
            {
              name: 'Start app',
              // eslint-disable-next-line
              type: sbPromotion.RULE_TYPE_TRIGGER,
              extraFields: extraFields
            },
            ...rules
          ],
          onSubmit: function (data) {

          },
          headerImage: this.mainLogo,
          headerText: null,
          formButtonText: '<i class="fa fa-paper-plane-o" role="presentation"></i> Submit & Continue',
          formCancelText: '<i class="fa fa-frown-o" role="presentation"></i> No, thanks',
          formTitle: this.namecapture_form && this.$tr(this.namecapture_form.text) ? this.$tr(this.namecapture_form.text) : 'Tell us a little about yourself',
          formLabels: ncSettings && ncSettings.formLabels ? ncSettings.formLabels : {},
          extraLink: extraLink || null
        })
        if (showDefaultNamecaptureForm) {
          this.onceShowForm()
        }
      }
      document.head.appendChild(promoScript)
    }
  },
  computed: {
    ...mapState({
      menu_links: state => state.college.settings.menu_links,
      namecapture_form: state => state.college.settings.namecapture_form
    }),
    ...mapState('poi', {
      currentTour: state => state.currentTour,
      unfinishedTour: state => state.unfinishedTour
    })
  },
  methods: {
    ...mapMutations('poi', ['setCurrentPoiList', 'setCurrentTour', 'clearUnfinishedTour']),
    onceShowForm: function () {
      var state = onceForm.notify('Start app')
      if (state) {
        state.on('open', function () {
          let lastNameContainer = document.querySelector('.sbnc-form-lastname')
          let nameContainer = document.querySelector('.sbnc-row-name')

          if (lastNameContainer && nameContainer) {
            nameContainer.after(lastNameContainer)
          }
        })
      }
    },
    hideShare: function () {
      this.shareOpen = false
    },
    cancelTour: function () {
      this.clearUnfinishedTour()
    },
    continueTour: function () {
      let currentTour = { type: this.unfinishedTour.type, tour: this.unfinishedTour.tour }

      this.setCurrentPoiList(this.unfinishedTour.poiList)
      this.setCurrentTour(currentTour)
      this.$router.push({ name: 'PoiDirections', params: { id: this.unfinishedTour.lastVisitedPoi.id } })
    },
    currentYear () {
      let current = new Date()
      return current.getFullYear()
    },
    truncate: function (input) {
      if (input.length > 230) {
        return input.substring(0, 230) + '...'
      } else {
        return input
      }
    },
    getUrl () {
      return window.location.origin
    }
  },
  watch: {
    $route (to, from) {
      if (this.namecaptureSettings.rules && this.namecaptureSettings.rules.length > 0) {
        this.namecaptureSettings.rules.forEach(rule => {
          onceForm.notify(rule.name)
        })
      }
    }
  }
}
</script>
